import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';

interface GuidesPaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export function GuidesPagination({ page, totalPages, onChange }: GuidesPaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, value) => onChange(value)}
        shape="rounded"
        sx={{
          '& .MuiPaginationItem-root': {
            color: 'text.secondary',
            fontWeight: 600,
            '&:hover': {
              bgcolor: 'backgrounds.sectionAlt',
            },
          },
          '& .MuiPaginationItem-root.Mui-selected': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              bgcolor: 'primary.light',
            },
          },
        }}
      />
    </Box>
  );
}
